// extracted by mini-css-extract-plugin
export default {"event-item":"components-hotel-short-term-rental-short-term-rental-event-item-module__event-item"};